import { render } from "./Paypast.vue?vue&type=template&id=a0c4d254&scoped=true"
import script from "./Paypast.vue?vue&type=script&lang=js"
export * from "./Paypast.vue?vue&type=script&lang=js"

import "./Paypast.vue?vue&type=style&index=0&id=a0c4d254&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0c4d254"]])

export default __exports__